import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
import { themes } from 'Components/widgets/be-transport-details/BeTransportDetails.themes';
const SNCF_ID = 'SNC';
type TransportDetailsCompanyLogoProps = {
  companyOperator: {
    id: string;
    label: string;
    logo: string;
  };
  manyCompanies: boolean;
  theme: 'mobile' | 'desktop';
};
export const TransportDetailsCompanyLogo = ({
  companyOperator,
  manyCompanies,
  theme,
}: TransportDetailsCompanyLogoProps) => {
  const { thCompanyLogo, thManyCompanies } = themes()[theme];
  const companyHasLogo = !!companyOperator.logo;
  return (
    <div className={thCompanyLogo} data-testid="TransportDetailsCompanyLogo">
      {manyCompanies || !companyHasLogo ? (
        <div className={classnames('flex justify-center rounded-8 bg-pearl', thManyCompanies)}>
          <Icon className="-my-5 text-lightGrey" name={ICONS.MULTIPLE_COMPANIES} width="2rem" />
        </div>
      ) : (
        <img
          src={companyOperator.logo} // SNCF logo is shaped differently than other logos and should have a specific width
          width={companyOperator.id === SNCF_ID ? 65 : 110}
          alt={companyOperator.label}
        />
      )}
    </div>
  );
};
